/**
 * Created by zzy on 2019/8/7.
 */
import MapNavigator from './MapNavigator.vue'
export default MapNavigator



// WEBPACK FOOTER //
// ./src/views/common/mapNavigator/index.js